import type {DispatchTimelineData} from '../dispatch-timeline/types'

/** Filters board projections by dispatch yard, keeping jobs without a yard. */
export function filterDispatchTimelineDataByYard(
    data: DispatchTimelineData,
    yardId?: string | null,
): DispatchTimelineData {
    if (!yardId) {
        return data
    }

    const isJobOnYardBoard = (job: {dispatchYardId?: string | null}) =>
        job.dispatchYardId == null || job.dispatchYardId === yardId

    return {
        ...data,
        unassignedJobs: data.unassignedJobs.filter(isJobOnYardBoard),
        assignments: data.assignments.filter(isJobOnYardBoard),
    }
}

/** Filters live board projections by the exact customer ID selected in the URL. */
export function filterDispatchTimelineDataByCustomer(
    data: DispatchTimelineData,
    customerId?: string | null,
): DispatchTimelineData {
    if (!customerId) {
        return data
    }

    return {
        ...data,
        unassignedJobs: data.unassignedJobs.filter((job) => job.customerId === customerId),
        assignments: data.assignments.filter((assignment) => assignment.customerId === customerId),
    }
}
